export default __webpack_public_path__ + "static/media/header.1058df56.jpg";